import { useEffect } from 'react';

import { MessageBus } from '@app-velocity/message-bus';

import { useNotifications } from '../useNotifications';

const messageBus = new MessageBus('users');

export const useNotificationsListener = () => {
  const { myInvitations } = useNotifications(true);

  useEffect(() => {
    if (!myInvitations) return;

    const active = myInvitations.filter((n) => !n.used);

    if (!active.length) return;

    const lastNotificationsCheck = localStorage.getItem(
      'notifications-checked'
    );

    localStorage.setItem(
      'notifications-checked',
      new Date().getTime().toString()
    );

    if (lastNotificationsCheck) {
      const lastTimestamp = Number(lastNotificationsCheck);

      if (lastTimestamp && !isNaN(lastTimestamp)) {
        const unchecked = active.filter(
          (notification) =>
            notification.createdAt && notification.createdAt >= lastTimestamp
        );

        if (!unchecked.length) return;
      }
    }

    messageBus.publish('modal:notifications:open');
  }, [myInvitations]);
};
